const accordion_images = {
  learnColor: require("../../assets/svgs/accordionLearnColor.svg"),
  practiceColor: require("../../assets/svgs/accordionPracticeColor.svg"),
  assessmentColor: require("../../assets/svgs/accordionAssessmentColor.svg"),
  learnWhite: require("../../assets/svgs/accordionLearnWhite.svg"),
  practiceWhite: require("../../assets/svgs/accordionPracticeWhite.svg"),
  assessmentWhite: require("../../assets/svgs/accordionAssessmentWhite.svg"),
  subTopicTasksUnlocked: require("../../assets/svgs/TaskUnlockedIconSvgIcon.svg"),
  subTopicTasksCompleted: require("../../assets/svgs/CompeltedTaskSvgIcon.svg"),
  subTopicTasksInProgress: require("../../assets/svgs/TaskInProgressSvgIcon.svg"),
  subTopicTasksLocked: require("../../assets/svgs/TaskLockedIconSvgIcon.svg"),
  doubtVin: require("../../assets/svgs/accordionDoubt.svg"),
  reminder: require("../../assets/svgs/accordionReminder.svg"),
  appreciation: require("../../assets/svgs/accordionAppreciation.svg"),
  levelUp: require("../../assets/svgs/levelUpTest.svg"),
  practiceHighlight: require("../../assets/svgs/accordionPracticeHighlight.svg"),
  learnHighlight: require("../../assets/svgs/accordionLearnHighlight.svg"),
  assessmentHighlight: require("../../assets/svgs/accordionAssessmentHighlight.svg"),
  experientialTaskButton: require("../../assets/svgs/experientialTask.svg"),
  experientialLearningButton: require("../../components/atoms/icons/experientialLearning.svg"),
  proficiency: require("../../assets/svgs/accordionProficiency.svg"),
  advanced: require("../../assets/svgs/accordionAdvanced.svg"),
  completedSideNav: require("../../assets/svgs/completedSideNav.svg"),
  inProgressSideNav: require("../../assets/svgs/inProgressSideNav.svg"),
  notStartedSideNav: require("../../assets/svgs/notStartedSideNav.svg"),
  experientialTaskCard: require("../../assets/svgs/experientialTaskCard.svg"),
  customSubtopicInfo: require("../../assets/svgs/accordionCustomSubtopicInfo.svg"),
  customSubtopicInfoBlack: require("../../assets/svgs/customSubtopicInfoBlack.svg"),
  customSubtopicInfoWhite: require("../../assets/svgs/customSubtopicInfo.svg"),
  updatesAppreciation: require("../../assets/svgs/updatesAppreciation.svg"),
  updatesReminder: require("../../assets/svgs/updatesReminder.svg"),
  updatesLevelUp: require("../../assets/svgs/updatesLevelUp.svg"),
  updatesTask: require("../../assets/svgs/updatesTask.svg"),
  updatesUnlock: require("../../assets/svgs/updatesUnlock.svg"),
  updatesAdvanced: require("../../assets/svgs/updatesAdvanced.svg"),
  updatesProficient: require("../../assets/svgs/updatesProficient.svg"),
  updatesExperiential: require("../../assets/svgs/updatesExperiential.svg"),
  updatesUnlockWithoutBackground: require("../../assets/svgs/updatesUnlockWithoutBackground.svg"),
  tickCircle: require("../../assets/svgs/tickCircle.svg"),
  roundArrow: require("../../assets/svgs/circleArrow.svg"),
  newTask: require("../../assets/svgs/newTask.svg"),
  noUpdates: require("../../assets/svgs/noUpdatesCase.svg"),
  schoolUpdatesArrow: require("../../assets/svgs/schoolUpdatesArrow.svg"),
  chapterEndAssessmentTaskIcon: require("../../assets/svgs/chapterEndAssessmentTaskIcon.svg"),
};

export default accordion_images;
